import type {
  DefinitionsFromApi,
  OverrideResultType,
  TagTypesFromApi
} from '@reduxjs/toolkit/query';

import {
  backendApi,
  FetchStatisticsMonitorOptionsApiResponse
} from './generated/backendApi';

type Definitions = DefinitionsFromApi<typeof backendApi>;
type TagTypes = TagTypesFromApi<typeof backendApi>;

type UpdatedDefinitions = Definitions & {
  // Only when overriding result type:
  //login: OverrideResultType<Definitions['login'], void>;
  fetchStatisticsMonitorOptions: OverrideResultType<
    Definitions['fetchStatisticsMonitorOptions'],
    FetchStatisticsMonitorOptionsApiResponse
  >;
};

const enhancedApi = backendApi.enhanceEndpoints<TagTypes, UpdatedDefinitions>({
  endpoints: {
    fetchStatisticsMonitorOptions: {
      transformResponse: (data: FetchStatisticsMonitorOptionsApiResponse) => {
        return {
          ...data,
          monitor_options: data.monitor_options.sort((a, b) =>
            a.value.localeCompare(b.value, undefined, { numeric: true })
          )
        };
      }
    }
  }
});

export const {
  useLoginMutation,
  useFetchStatisticsSoundOptionsQuery,
  useFetchStatisticsMonitorOptionsQuery,
  useFetchStatisticsClimateOptionsQuery,
  useFetchStatisticsDateRangeOptionsQuery,
  useFetchStatisticsRoutineOptionsQuery,
  useFetchStatisticsQuery,
  useFetchMonitorAvailableFirmwaresQuery,
  useFetchLatestMonitorFirmwareUpdateQuery,
  useUpdateMonitorFirmwareMutation,
  useFetchAccountsQuery,
  useSwitchAccountMutation,
  useLazyFetchAccountsQuery,
  useFetchDashboardMonitorOverviewByDateQuery,
  useFetchObservationsQuery,
  useFetchNotesQuery,
  useFetchIncidentsQuery
} = enhancedApi;

export { enhancedApi as backendApi };
